export default __webpack_public_path__ + "static/navigator-aae74efba7ac7879846f7da7ccc84b39.png";